export const animateProgress = (
	start: number,
	end: number,
	duration: number,
	onProgress: (value: number) => void
): Promise<void> => {
	return new Promise((resolve) => {
		const startTime = Date.now();

		const update = () => {
			const currentTime = Date.now();
			const elapsed = currentTime - startTime;
			const progress = Math.min(elapsed / duration, 1);

			const currentValue = start + (end - start) * progress;
			onProgress(Math.round(currentValue));

			if (progress < 1) {
				requestAnimationFrame(update);
			} else {
				resolve();
			}
		};

		requestAnimationFrame(update);
	});
};
